import { useAuthStore } from "@/lib/auth-store";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * True si el usuario autenticado es el solicitante dueño de la solicitud.
 *
 * Los pasos del wizard son visibles para Mesa de Control/Auditor/Administrador
 * en SOLO LECTURA (decisión P29) · las páginas usan este hook para calcular
 * `soloLectura = estaPostEnvio(estado) || !esDueno` y así deshabilitar toda
 * mutación cuando el viewer no es el dueño (el backend igualmente rechaza las
 * mutaciones de no-dueños · esto es solo UX).
 */
export function useEsDueno(sol: Pick<SolicitudDetalle, "solicitanteId">): boolean {
  const userId = useAuthStore((s) => s.user?.id);
  return userId === sol.solicitanteId;
}
